<template>
  <a-modal
    v-model:visible="visible"
    title="添加进度条"
    :width="397"
    wrap-class-name="modal-progressBar"
  >
    <div class="icon">
      <div class="border border-[#fff]/[0.3]" style="width: 173px !important">
        <Icon
          icon="progressBarPrompt.svg"
          :width="171"
          :height="171"
          fill="none"
        />
      </div>
      <p class="mt-6 -mb-[2px]">弧形进度条，请上传包含进度条本身的弧形切图</p>
    </div>
    <template #footer>
      <a-button key="back" @click="handleOk"> 知道了 </a-button>
    </template>
  </a-modal>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue';
const emits = defineEmits<{
  (event: 'addProgressBar'): void;
}>();

const visible = ref<boolean>(false);
const showModal = () => {
  visible.value = true;
};

const handleOk = () => {
  visible.value = false;
  emits('addProgressBar');
};
defineExpose({ showModal });

const handleKeyUp = (e: KeyboardEvent) => {
  e.stopPropagation();
  if (e.key === 'Enter') {
    handleOk();
  }
};

watch(visible, (val) => {
  if (val) window.addEventListener('keyup', handleKeyUp);
  else window.removeEventListener('keyup', handleKeyUp);
});
</script>
<style scoped>
.icon {
  padding-left: 90px;
}
p {
  margin-left: -95px;
  font-size: 16px;
}
</style>
<style lang="less">
.modal-progressBar {
  .ant-modal-content {
    background-color: #000000;
    border-radius: 20px;
    .ant-modal-header {
      border-radius: 20px 20px 0 0;
      background-color: #000000;
    }
  }
}
</style>
